// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.ranking.byClient': 'Ranking por cliente',
    'dashboard.ranking.byDestination': 'Ranking por destino',
    'dashboard.ranking.requested': 'Solicitadas',
    'dashboard.ranking.scheduled': 'Escaladas',
    'dashboard.ranking.empty': 'Sem cargas nesta seleção.',
  },
  en: {
    'dashboard.ranking.byClient': 'Ranking by customer',
    'dashboard.ranking.byDestination': 'Ranking by destination',
    'dashboard.ranking.requested': 'Requested',
    'dashboard.ranking.scheduled': 'Scheduled',
    'dashboard.ranking.empty': 'No loads in this selection.',
  },
  es: {
    'dashboard.ranking.byClient': 'Ranking por cliente',
    'dashboard.ranking.byDestination': 'Ranking por destino',
    'dashboard.ranking.requested': 'Solicitadas',
    'dashboard.ranking.scheduled': 'Programadas',
    'dashboard.ranking.empty': 'Sin cargas en esta selección.',
  },
}
